// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header-container":"header-container"};